import { hotList, siteName, timeline } from '@/mocks/chigua';

const HERO_IMG =
  'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photomontage%20evoking%20breaking%20viral%20news%20energy%2C%20abstract%20warm%20coral%20red%20and%20amber%20light%20flares%20sweeping%20across%20a%20clean%20cream%20studio%2C%20soft%20silhouettes%20of%20people%20holding%20phones%20watching%20a%20glowing%20central%20screen%2C%20dramatic%20rim%20light%2C%20fine%20film%20grain%2C%20high%20contrast%2C%20magazine%20cover%20aesthetic%2C%20no%20text&width=1600&height=900&seq=hero-lead-001&orientation=landscape';

export default function Hero() {
  const lead = timeline[0];
  const top3 = hotList.slice(0, 3);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: siteName,
        url: 'https://wuhl.top/',
        logo: 'https://wuhl.top/favicon.svg',
        description: '聚合今日热点、娱乐八卦与全网爆点的中文资讯平台。',
      },
      {
        '@type': 'WebSite',
        name: siteName,
        url: 'https://wuhl.top/',
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: { '@type': 'EntryPoint', urlTemplate: 'https://wuhl.top/?q={search_term_string}' },
          'query-input': 'required name=search_term_string',
        },
      },
    ],
  };

  return (
    <section id="top" className="relative overflow-hidden bg-foreground-950 text-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <img
        src={HERO_IMG}
        alt="吃瓜网爆今日热点编辑部风格首屏背景"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-background-50/0"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/40 to-transparent"></div>

      <div className="relative mx-auto w-full max-w-7xl px-4 pb-16 pt-14 md:px-6 md:pb-24 md:pt-20">
        <div className="flex max-w-2xl flex-col items-start gap-5">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-accent-500/15 px-3 py-1 text-xs text-accent-200">
            <i className="ri-chat-3-line"></i>
            今日全网速览已更新 {timeline.length * 3}+ 条讨论热点
          </span>

          <h1 className="heading-font text-3xl font-extrabold leading-tight md:text-5xl">
            一条线，把今天的瓜都吃明白
          </h1>

          <p className="text-sm leading-relaxed text-background-100 md:text-base">
            {siteName}把{' '}
            <strong className="font-semibold text-accent-300">今日热点</strong>与{' '}
            <strong className="font-semibold text-accent-300">全网爆点</strong>
            按时间聚成一条信息流：刚起来的猛料、被反复顶起的热门事件、正在涨的关注点，全部排在同一根时间轴上。顺着看，就知道今天该聊什么。
          </p>

          <div className="mt-1 flex flex-col gap-3 sm:flex-row">
            <a
              href="#ts"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-flashlight-fill"></i> 看今日速览
            </a>
            <a
              href="#rank"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-200/40 bg-background-50/5 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/15"
            >
              <i className="ri-fire-line"></i> 进全网热榜
            </a>
          </div>

          {/* live lead strip */}
          <div className="mt-4 w-full max-w-xl rounded-lg border border-background-200/15 bg-foreground-950/40 p-4 backdrop-blur-md">
            <div className="mb-2 flex items-center justify-between">
              <span className="flex items-center gap-1.5 text-xs font-semibold tracking-widest text-accent-300">
                <span className="relative flex h-2 w-2">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75"></span>
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500"></span>
                </span>
                正在发酵的头条
              </span>
              <span className="text-[10px] text-background-100/70">热度 {lead.heat}%</span>
            </div>
            <h2 className="heading-font text-lg font-bold leading-snug text-background-50 md:text-xl">
              {lead.title}
            </h2>
            <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-background-100/90 md:text-sm">
              {lead.summary}
            </p>
            <a
              href="#ts"
              className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-accent-300 transition-colors hover:text-accent-200"
            >
              进入这条讨论 <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>

      {/* top3 ticker under hero */}
      <div className="relative border-t border-background-200/10 bg-foreground-950/70 backdrop-blur">
        <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-px px-4 py-3 md:grid-cols-3 md:px-6">
          {top3.map((h) => (
            <a key={h.id} href="#rank" className="group flex items-center gap-3 py-1.5">
              <span
                className={`heading-font text-2xl font-extrabold ${
                  h.rank === 1 ? 'text-accent-400' : 'text-background-200/40'
                }`}
              >
                {String(h.rank).padStart(2, '0')}
              </span>
              <span className="flex min-w-0 flex-col">
                <span className="truncate text-xs text-background-100 transition-colors group-hover:text-accent-300 md:text-sm">
                  {h.title}
                </span>
                <span className="text-[10px] text-background-100/50">热度 {h.heat}</span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}